module.exports = __webpack_public_path__ + "static/img/icon_logo.d4afc7a1.png";